export const WELLO_IMAGE_PREFIX_URL = 'https://cdn.welfarehello.com';

export const IMAGE_PLACEHOLDER =
  'https://cdn.welfarehello.com/static/common/placeholder-thumbnail.png';
